/* eslint-disable @typescript-eslint/no-explicit-any */
import { ActionTree } from "vuex";
import { RootState } from "../types";
import { answersInt } from "./types";
export const actions: ActionTree<answersInt, RootState> = {};
